/*
 * @Author: Chris 
 * @Date: 2022-09-20 09:28:47 
 * @Last Modified by: Chris
 * @Last Modified time: 2022-09-26 15:16:22
 * @msg element下拉框不可删除值去掉关闭按钮 
 * 组织架构修改角色情况下，主要的三个角色不能被修改
 * 角色id为1，2，3的角色不能在输入款里点击删除
 */

import Vue from "vue";

Vue.directive("defaultSelect", {
    componentUpdated(el, bindings) {
        const [defaultValues] = bindings.value
        const dealStyle = function (tags) {
            // 因为不可删除原有值，所以原有值的index是不会变的，也就是将前n个tag的close隐藏掉即可。n即已有值的长度defaultValues.length
            tags.forEach((el, index) => {
                if (index <= defaultValues.length - 1 && ![...el.classList].includes('select-tag-close-none')) {
                    el.classList.add('none')
                }
            })
        }
        /**
         * 设置样式 隐藏close icon
         * */
        const tags = el.querySelectorAll('.el-tag__close')
        if (tags.length === 0) {
            // 初始化tags为空处理
            setTimeout(() => {
                const tagTemp = el.querySelectorAll('.el-tag__close')
                dealStyle(tagTemp)
            })
        } else {
            dealStyle(tags)
        }
    }
});